import PensionsInfoAftalerView from './PensionsInfoAftalerView';

export default PensionsInfoAftalerView;
